var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    {
      staticClass: "px-1 py-1",
      attrs: { fluid: "", "data-testid": "collection-card" },
    },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { cols: "12" } },
            [
              _c(
                "v-card",
                {
                  staticClass: "pl-3 pr-4 py-2",
                  attrs: { elevation: "0", outlined: "" },
                },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex justify-space-between py-0 pr-2",
                          attrs: { cols: "12" },
                        },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "flex-grow-1",
                              attrs: {
                                to: "/collections/" + _vm.collection.id,
                              },
                            },
                            [
                              _c("div", { staticClass: "d-flex flex-column" }, [
                                _c(
                                  "h4",
                                  {
                                    staticClass:
                                      "mb-0 primary--text font-weight-bold",
                                    class: {
                                      "text--darken-3":
                                        !_vm.$vuetify.theme.dark,
                                      "text--lighten-3":
                                        _vm.$vuetify.theme.dark,
                                    },
                                    attrs: {
                                      "data-testid": "collection-card-name",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(_vm.collection.name) +
                                        "\n                    "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.collection.createdBy
                                  ? _c(
                                      "p",
                                      {
                                        staticClass:
                                          "body-2 primary--text subheader-font mb-0 mt-0",
                                        attrs: {
                                          "data-testid":
                                            "collection-card-creator",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            `${_vm.$t("general.createdBy")} ${
                                              _vm.collection.createdByName ||
                                              _vm.collection.createdBy
                                            }`
                                          ) + " "
                                        ),
                                        _vm.collection.supervised
                                          ? _c("span", [
                                              _vm._v(
                                                "(" +
                                                  _vm._s(
                                                    _vm.collection.userType
                                                  ) +
                                                  ")"
                                              ),
                                            ])
                                          : _vm._e(),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "d-flex align-center justify-end" },
                            [
                              _vm.embedded
                                ? _c(
                                    "div",
                                    { staticClass: "d-flex align-center" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "primary white--text px-3 py-2 rounded monospace-font font-weight-bold d-flex align-center justify-center",
                                          staticStyle: {
                                            "min-width": "50px",
                                            height: "100%",
                                          },
                                          attrs: {
                                            "data-testid":
                                              "collection-card-player-count",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(_vm.nPlayers) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              (_vm.collection.createdBy ===
                                _vm.currentUser.username ||
                                _vm.userHasRole("ROLE_ADMIN")) &&
                              !_vm.embedded
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        "data-testid":
                                          "collection-card-pin-button",
                                        icon: "",
                                        "x-small": "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onPinClick()
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticStyle: { "font-size": "12px" },
                                          attrs: {
                                            small: "",
                                            color: _vm.collection.pinned
                                              ? "secondary"
                                              : "grey lighten-1 z-10",
                                          },
                                        },
                                        [_vm._v("fa-thumbtack")]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              (_vm.collection.createdBy ===
                                _vm.currentUser.username ||
                                _vm.userHasRole("ROLE_ADMIN")) &&
                              !_vm.embedded
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        "data-testid":
                                          "collection-card-delete-button",
                                        icon: "",
                                        "x-small": "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onDeleteClick()
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            small: "",
                                            color: "grey lighten-1 z-10",
                                          },
                                        },
                                        [_vm._v("delete")]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.embedded
                    ? _c("v-divider", { staticClass: "my-2" })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    { attrs: { to: "/collections/" + _vm.collection.id } },
                    [
                      _c(
                        "v-row",
                        [
                          !_vm.$vuetify.breakpoint.smAndDown && !_vm.embedded
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "pb-1 py-1",
                                  attrs: { cols: "6" },
                                },
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass:
                                            "d-flex align-end justify-space-between py-0",
                                          attrs: { cols: "12" },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-2 ml-2 orange--text text--darken-3",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "positions.goalkeepers"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-2 font-weight-medium primary--text d-flex justify-end mx-2",
                                            },
                                            [_vm._v(_vm._s(_vm.goalKeepers))]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass:
                                            "d-flex align-end justify-space-between py-0",
                                          attrs: { cols: "12" },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-2 ml-2 indigo--text text--darken-1",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("positions.defenses")
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-2 font-weight-medium primary--text d-flex justify-end mx-2",
                                            },
                                            [_vm._v(_vm._s(_vm.defenders))]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass:
                                            "d-flex align-end justify-space-between py-0",
                                          attrs: { cols: "12" },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-2 ml-2 success--text text--darken-2",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "positions.midfielders"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-2 font-weight-medium primary--text d-flex justify-end mx-2",
                                            },
                                            [_vm._v(_vm._s(_vm.midfielders))]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass:
                                            "d-flex align-end justify-space-between py-0",
                                          attrs: { cols: "12" },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-2 ml-2 red--text text--darken-3",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("positions.forwards")
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-2 font-weight-medium primary--text d-flex justify-end mx-2",
                                            },
                                            [_vm._v(_vm._s(_vm.forwards))]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            {
                              staticClass: "pb-1 pt-0",
                              attrs: { cols: "12", sm: _vm.embedded ? 12 : 6 },
                            },
                            [
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "d-flex align-end justify-space-between py-1",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "body-2 primary--text subheader-font",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "collections.totalMarketValue"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "body-2 font-weight-medium primary--text",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("formatCash")(
                                                _vm.totalMarketValue,
                                                _vm.currentUserRate
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "d-flex align-end justify-space-between py-1",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "body-2 primary--text subheader-font",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "collections.avgMarketValue"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "body-2 font-weight-medium primary--text",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("formatCash")(
                                                _vm.avgMarketValue,
                                                _vm.currentUserRate
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.embedded && _vm.uniquePositions.length > 0
                                ? _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass:
                                            "d-flex align-end justify-space-between py-1",
                                          attrs: { cols: "12" },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-2 primary--text subheader-font",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "playerRecruitment.positions"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-center",
                                            },
                                            [
                                              _vm._l(
                                                _vm.displayedPositions,
                                                function (posId, index) {
                                                  return _c(
                                                    "v-chip",
                                                    {
                                                      key: index,
                                                      staticClass:
                                                        "ml-1 monospace-font",
                                                      attrs: {
                                                        "x-small": "",
                                                        color:
                                                          _vm.getPositionChipColor(
                                                            posId
                                                          ),
                                                        "text-color": "white",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.getPositionCode(
                                                              posId
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              _vm._v(" "),
                                              _vm.hiddenPositionsCount > 0
                                                ? _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: {
                                                        top: "",
                                                        color:
                                                          "lightSecondary lighten-4",
                                                        "max-width": "300",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function ({
                                                              on,
                                                              attrs,
                                                            }) {
                                                              return [
                                                                _c(
                                                                  "v-chip",
                                                                  _vm._g(
                                                                    _vm._b(
                                                                      {
                                                                        staticClass:
                                                                          "ml-1 monospace-font",
                                                                        attrs: {
                                                                          "x-small":
                                                                            "",
                                                                          color:
                                                                            "grey darken-1",
                                                                          "text-color":
                                                                            "white",
                                                                        },
                                                                      },
                                                                      "v-chip",
                                                                      attrs,
                                                                      false
                                                                    ),
                                                                    on
                                                                  ),
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          +" +
                                                                        _vm._s(
                                                                          _vm.hiddenPositionsCount
                                                                        ) +
                                                                        "\n                        "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        false,
                                                        817931431
                                                      ),
                                                    },
                                                    [
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "d-flex flex-wrap align-center",
                                                        },
                                                        _vm._l(
                                                          _vm.hiddenPositions,
                                                          function (
                                                            posId,
                                                            index
                                                          ) {
                                                            return _c(
                                                              "v-chip",
                                                              {
                                                                key: index,
                                                                staticClass:
                                                                  "ma-1 monospace-font",
                                                                attrs: {
                                                                  "x-small": "",
                                                                  color:
                                                                    _vm.getPositionChipColor(
                                                                      posId
                                                                    ),
                                                                  "text-color":
                                                                    "white",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      _vm.getPositionCode(
                                                                        posId
                                                                      )
                                                                    ) +
                                                                    "\n                        "
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            2
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "d-flex align-end justify-space-between py-1",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "body-2 primary--text subheader-font",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("collections.avgAge"))
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "body-2 font-weight-medium primary--text",
                                        },
                                        [_vm._v(_vm._s(_vm.avgAge) + "yo")]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }